import store from './store'

export default new Promise(async (resolve) => {
    await store.dispatch('courseCategory/fetchCourseCategory')

    if (store.getters['user/isLogged']) {
        try {
          await store.dispatch('user/fetchUser')
          await store.dispatch('subscription/fetchSubscription')
          store.dispatch('notification/fetchUnreadNotificationCount')
        } catch (err) {
          console.log('[ERROR] ' + err)
          window.location.reload()
        }
    }
    
    resolve()
})